
 import {useState} from 'react';
 import { Overlay } from "googlemaps-react-primitives";
 import { useHistory } from 'react-router-dom';
import { IoMdClose } from 'react-icons/io';
 import './MultipleOffersMarker.css';
 import MarkerSingleOffer from './MarkerSingleOffer/MarkerSingleOffer';
 import { useAtom } from 'jotai';
 import { useDetailedOffer } from '../../../data/GlobalStates';

 const MultipleOffersMarker = ({position, offer, offersFromSameCity, setMapCenterLat, setMapCenterLong, setmapZoomLevel, mapZoomLevel}) => {

  const history = useHistory();
  const [ displayOffersNumber, setDisplayOffersNumber] = useState(true);

  //stany globalne:
  const [ DetailedOffer, setDetailedOffer] = useAtom(useDetailedOffer);

  let offersFromSameCityNum = offersFromSameCity.filter(i => i.city === offer.city).length

  const openOfferDetails = (offer) => {
   setDetailedOffer(offer)
   history.push({
    pathname: `/Oferty/${offer.id}/${offer.title.replace(/[' ']/g,'-')}`,
    from: 'Map',
   // state: company.name
  })
  };

const offersNumCounter = (offersFromSameCityNum) => {
  const n = Math.abs(offersFromSameCityNum);

  if (n === 1) return "oferta";

  const lastDigit = n % 10;
  const lastTwoDigits = n % 100;

  if (lastDigit >= 2 && lastDigit <= 4 && !(lastTwoDigits >= 12 && lastTwoDigits <= 14)) {
    return "oferty";
  }

  return "ofert";
};

  const switchDisplayType = () => {
    setDisplayOffersNumber(!displayOffersNumber)
    setMapCenterLat(position.lat - 5)
    setMapCenterLong(position.lng + 5)
    setmapZoomLevel(5)
  };

 

  const displayCityOffersNumber = () => {
    return (
     <Overlay position={{ lat: position.lat, lng: position.lng }}>
      <div className='MultipleMarkerMainContainer' onClick={() => switchDisplayType()}>
        { mapZoomLevel > 8 ? <p>{offer.city}</p> : null} 
        { mapZoomLevel < 6 ? <p className='MultipleMarkerMainContainerValueSmall'>{offersFromSameCityNum}</p> : null} 
        { mapZoomLevel >= 6 ? <p className={mapZoomLevel > 8 ? 'MultipleMarkerMainContainerValueSquared' : 'MultipleMarkerMainContainerValue'}>{offersFromSameCityNum}</p> : null} 
        { mapZoomLevel > 8 ? <p>{offersNumCounter(offersFromSameCityNum)}</p> : null} 
      </div>
     </Overlay>
)
};


  const displayCityOffers = () => {

  if (mapZoomLevel < 10 && displayOffersNumber) {
     return (
        displayCityOffersNumber()
   )
  } else if (mapZoomLevel < 10 && !displayOffersNumber) {
    return (
        <Overlay position={{ lat: position.lat, lng: position.lng }}>
         <div className='MultipleMarkerOffersContainer'>
            <div className='MultipleMarkerIconContainer'>
              { mapZoomLevel >  8 ? null : <IoMdClose className='MultipleMarkerCloseIcon' onClick={() => switchDisplayType()}/> }
            </div>
            <p className='OffersCityName'>{offer.city}</p>
            <div className='MultipleMarkerOffersDisplayContainer'>
              {offersFromSameCity.filter(z => z.city === offer.city).map(offer =>
               <MarkerSingleOffer
                 key={offer.id}
                 offer={offer}
                 openOfferDetails={openOfferDetails}
                 mapZoomLevel={mapZoomLevel}
                 autoOpen={true}
            />
           )}
            </div>
         </div>
        </Overlay>
   )
  } else if (mapZoomLevel >= 10) {
    return (
        <Overlay position={{ lat: position.lat, lng: position.lng }}>
         <div className='MultipleMarkerOffersContainer'>
            <div className='MultipleMarkerIconContainer'>
              { mapZoomLevel >  8 ? null : <IoMdClose className='MultipleMarkerCloseIcon' onClick={() => switchDisplayType()}/> }
            </div>
            <p>{offer.city}</p>
            <div className='MultipleMarkerOffersDisplayContainer'>
              {offersFromSameCity.filter(z => z.city === offer.city).map(offer =>
               <MarkerSingleOffer
                 key={offer.id}
                 offer={offer}
                 openOfferDetails={openOfferDetails}
                 mapZoomLevel={mapZoomLevel}
                 autoOpen={false}
            />
           )}
            </div>
         </div>
        </Overlay>
   )
  }
  }

  return (
    <div>
        {displayCityOffers()}
    </div>
  )
 };

 export default MultipleOffersMarker;




